import axios from './rest-axios';

const getStocks = (page, size, year, type, search, sortField, sortOrder) => {
    const params = {page, size, year, type};
    if (search) params.search = search;
    if (sortField) params.sortField = sortField;
    if (sortOrder) params.sortOrder = sortOrder;
    return axios.get(`/manage/stocks`, params);
};
const getStocksById = id => axios.get(`/manage/stocks/${id}`);
const addStock = stock => axios.post(`/manage/stocks`, stock);
const updateStock = stock => axios.put(`/manage/stocks/${stock.id}`, stock);
const deleteStock = id => axios.delete(`/manage/stocks/${id}`);
const copyStocksFromPreviousYear = (year) => axios.post(`/manage/stocks/copy`, {year});

export {
    getStocks,
    getStocksById,
    addStock,
    updateStock,
    deleteStock,
    copyStocksFromPreviousYear,
}
